import React from 'react';
import { connect } from 'react-redux';
import { mapRoleToProps, mapRoleToPropsType } from '../../../redux/entities/user';

type RoleProtectedComponentProps = mapRoleToPropsType & {
  children: React.ReactNode;
  allowedRoles: string[];
};

const normalize = (s: string) => (s ?? '').trim().toLowerCase();

const RoleProtectedComponentInner = ({ children, roleName, allowedRoles }: RoleProtectedComponentProps) => {
  // If role not ready yet (store hydrating), render nothing to avoid flicker
  if (!roleName) return null;

  const normalizedRole = normalize(roleName);
  const normalizedAllowed = (allowedRoles || []).map(normalize);

  const isAllowed = normalizedAllowed.includes(normalizedRole);
  return isAllowed ? <>{children}</> : null;
};

export const RoleProtectedComponent = connect(mapRoleToProps)(RoleProtectedComponentInner);
